import { AdminGetters, AdminActions, AdminMutations } from '@/app/features/admin/admin.keys';
import { adminService as svc } from '@/app/features/admin/admin.service';

export const getInitialState = () => {
  return {
    emailLogs: [],
    emailLogsRecordCount: 0,
    emailLogsPaginationParams: {
      recordsPerPage: 50,
      offset: 0
    },
    emailLogsSortParameters: {
      sortBy: 'none',
      sortDirection: 'desc'
    }
  };
};

export const adminStore = {
  state: getInitialState(),
  getters: {
    [AdminGetters.EmailLogs]: state => state.emailLogs,
    [AdminGetters.EmailsPerPage]: state => state.emailLogsPaginationParams.recordsPerPage,
    [AdminGetters.CurrentEmailLogOffset]: state => state.emailLogsPaginationParams.offset,
    [AdminGetters.EmailLogsCount]: state => state.emailLogsRecordCount
  },
  actions: {
    [AdminActions.RetrieveEmailLogs]: ({ state, commit, dispatch }) => {
      dispatch(AdminActions.RetrieveEmailLogsCount);
      return svc.fetchEmailLogs(state.emailLogsPaginationParams).then(res => {
        commit(AdminMutations.UpdateEmailLogs, res);
      });
    },
    [AdminActions.RetrieveEmailLogsCount]: ({ commit }) => {
      return svc.fetchEmailLogRecordCount().then(res => {
        commit(AdminMutations.UpdateEmailLogsCount, res);
      });
    },
    [AdminActions.SetPaginationParams]: ({ commit, dispatch }, params) => {
      commit(AdminMutations.SetPaginationParams, params);
      dispatch(AdminActions.RetrieveEmailLogs);
    }
  },
  mutations: {
    [AdminMutations.UpdateEmailLogs]: (state, payload) => {
      state.emailLogs = payload;
    },
    [AdminMutations.UpdateEmailLogsCount]: (state, payload) => {
      state.emailLogsRecordCount = payload;
    },
    [AdminMutations.SetPaginationParams]: (state, payload) => {
      state.emailLogsPaginationParams = payload;
    }
  }
};
